<template>
  <div>
    <HeaderEFTG ref="headerEFTG"></HeaderEFTG>

    <div class="container">
      <div class="box card">
        <div class="box cardImg">
          <img src="../assets/cexius-logo.webp" alt="..." />
        </div>
        <div class="info">
          <h3>Cexius</h3>
          <p>Advanced crypto exchange</p>
          <a href="https://cexius.com/trade/BLURT-USDT" class="btn btn-primary" target="_blank">Trade Now</a>
        </div>
      </div>
      <div class="box card">
        <div class="box cardImg">
          <img src="../assets/hive-engine.png" alt="..." />
        </div>
        <div class="info">
          <h3>Hive Engine</h3>
          <p>Exchange powered by Hive</p>
          <a href="https://hive-engine.com/?p=market&t=SWAP.BLURT" class="btn btn-primary" target="_blank">Trade Now</a>
        </div>
      </div>
      <div class="box card">
        <div class="box cardImg">
          <img src="../assets/tribaldex-logo.png" alt="..." />
        </div>
        <div class="info">
          <h3>Tribaldex Exchange</h3>
          <p>Exchange powered by Hive-Engine</p>
          <a href="https://tribaldex.com/trade/SWAP.BLURT" class="btn btn-primary" target="_blank">Trade Now</a>
        </div>
      </div>
      <div class="box card">
        <div class="box cardImg">
          <img src="../assets/tribaldex-logo.png" alt="..." />
        </div>
        <div class="info">
          <h3>Tribaldex Swap</h3>
          <p>Swap pools powered by Hive-Engine</p>
          <a href="https://tribaldex.com/swap?from=SWAP.HIVE&to=SWAP.BLURT" class="btn btn-primary"
            target="_blank">Trade Now</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderEFTG from "@/components/HeaderEFTG";
export default {
  name: "Exchanges",
  components: {
    HeaderEFTG,
  }
}
</script>
<style scoped>
.container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.box {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 4px 8px 0 rgba(0, 0, 0, 0.19);
  border-radius: 10px;
  justify-content: center;
}

.card {
  margin: 20px;
  width: 300px;
  min-width: 300px;
  height: 300px;
  transition: 0.5s;
}

.card:hover {
  border: 1px solid red;
  border-radius: 30px;
  scale: 1.05;
}

.cardImg {
  height: 33%;
  width: 90%;
  position: relative;
  top: 20px;
  left: 5%;
  margin-bottom: 30px;
  justify-content: center;
  align-items: center;
}

.card .cardImg img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
  max-width: 90%;
  max-height: 90%;
  display: block;
  margin: auto;
}

.info {
  position: relative;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
}

.card .info h3 {
  color: rgb(70, 66, 66);
}

.card .info p {
  color: rgb(41, 201, 49);
}

.ligne {
  display: flex;
}
</style>
